import React, { Component } from "react";
import { styled } from "../../../stitches.config";
import Link from "../../../components/Link";
import Slider from "react-slick";

import dots from "./assets/dots.svg";
import sticker from "./assets/nakladka.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

class AtavistTestingSlider extends Component {
  render() {
    const { header, articles } = this.props.blockData;

    const settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      centerPadding: "10px",
      responsive: [
        {
          breakpoint: 1350,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            arrows: true,
            centerPadding: "10px",
          },
        },
        {
          breakpoint: 1080,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            arrows: true,
            centerPadding: "10px",
          },
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            arrows: true,
            centerPadding: "10px",
          },
        },
        {
          breakpoint: 560,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            infinite: true,
            arrows: true,
            centerPadding: "10px",
          },
        },
      ],
    };
    return (
      <StyledBackground>
        <StyledAtavistTestingSlider>
          <Title>
            <Dots />
            {header}
          </Title>
          <Slider {...settings}>
            {articles.reverse().map((article) => (
              <Link to={article?.url} style={{ display: "block" }}>
                <Slide>
                  <Sticker></Sticker>
                  <img src={article?.img} alt={""} />
                  <SlideText className="slide-text">
                    <p className="title">{article?.title}</p>
                    <p>{article.description}</p>
                  </SlideText>
                </Slide>
              </Link>
            ))}
          </Slider>
        </StyledAtavistTestingSlider>
      </StyledBackground>
    );
  }
}

const StyledBackground = styled("div", {
  background: "#F5F5F5 !important",
  padding: "56px 30px 60px 30px",
  width: "100%",
  "@media(min-width: 1080px)": {
    margin: "0px auto 70px auto",
  },
  "@media(min-width: 1850px)": {
    margin: "0 0 70px 0",
  },
})

const StyledAtavistTestingSlider = styled("div", {
  color: "#131212",
  margin: "0 auto",
  "@media(min-width: 1080px)": {
    maxWidth: "1300px",
  },
  "@media(min-width: 1850px)": {
    marginLeft: "calc(50% - 748px)",
  },

  ".slick-slide .slick-center": {
    transition: "transform 500ms",
  },

  ".slick-slide": {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },

  ".slick-list": {
    padding: "0px",
  },

  ".slick-arrow": {
    "&:before": {
      color: "black",
    },
  },

  ".slick-active": {
    transform: "scale(1)!important",
  },

  a: {
    "&:hover": {
      textDecoration: "none !important",
    },
  },
});

const Dots = styled("div", {
  backgroundImage: `url("${dots}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  height: "28px",
  width: "12px",
  marginRight: "14px",
  marginTop: "2px",
  flexShrink: "0",
});

const Title = styled("div", {
  fontSize: "34px",
  lineHeight: "32px",
  fontWeight: "700",
  fontFamily: "$grotesk",
  display: "flex",
  justifyContent: "center",
  margin: "0px 0 49px 0",
  "@bp4": {
    justifyContent: "flex-start",
    margin: "0px 0 40px 0",
  },
});

const Sticker = styled("div", {
  width: "40px",
  height: "55px",
  position: "absolute",
  top: "10px",
  right: "20px",
  backgroundImage: `url("${sticker}")`,
  backgroundSize: "cover",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  zIndex: 10,
});

const Slide = styled("div", {
  width: "236px",
  height: "306px",
  cursor: "pointer",
  position: "relative",

  "&:hover": {
    ".slide-text": {
      background: "#FE80A5",
    },
  },

  img: {
    height: "200px",
    width: "236px",
    backgroundColor: "white",
    position: "relative",
  },
});

const SlideText = styled("div", {
  textAlign: "center",
  height: "99px",
  width: "236px",
  background: "#FEDDE8",
  transition: "0.3s",
  padding: "8px 19px 0 19px",
  overflow: "hidden",
  p: {
    fontSize: "20px",
    lineHeight: "22px",
    margin: "0px",
    color: "#131212 !important",
    "&:hover": {
      color: "#131212 !important",
    },
  },
  ".title": {
    fontWeight: "700",
  },
});

export default AtavistTestingSlider;
